"use client";

import { useQuery } from "@tanstack/react-query";
import type { BuildQuestionnaireRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { buildQuestionnaire } from "../api/buildQuestionnaire";
import { thoughtKeys } from "./keys";

export default function useBuildQuestionnaireQuery(
  request: BuildQuestionnaireRequest,
  {
    enabled = true,
    refreshKey = 0,
  }: { enabled?: boolean; refreshKey?: number } = {},
) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: thoughtKeys.questionnaire(request, refreshKey),
    queryFn: () => buildQuestionnaire(accessToken, request),
    enabled: Boolean(accessToken) && enabled,
  });
}
